const api_path =
  window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : "https://rateyourlandlordpdx.com/api"; //window.location.hostname === 'localhost' ? 'http://localhost:3001' : '/api'

export type OrgInterest = {
  complex: string;
  dayTime: string;
  space: string;
  leading: string;
  name: string;
  email: string;
  other: string;
};

export function submitContact(contact: any) {
  return fetch(`${api_path}/submit-contact`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify(contact),
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

export function getStats() {
  return fetch(`${api_path}/stats`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  }).then((result) => result.json());
}

export function submitOrgInterest(orgInterest: OrgInterest) {
  return fetch(`${api_path}/submit-org-interest`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify(orgInterest),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
